import type React from 'react';

import { usePetitionDetails } from '../../../hooks/petitionDetails';

import { SignatureStatsActiveContainer } from './SignatureStatsActiveContainer';
import { SignatureStatsClosedContainer } from './SignatureStatsClosed';

const SignatureStatsContainerInner: React.FC = () => {
	const { status } = usePetitionDetails();

	if (status === 'CLOSED') {
		return <SignatureStatsClosedContainer />;
	}

	if (status === 'VICTORY') {
		return null;
	}

	return <SignatureStatsActiveContainer />;
};

export const SignatureStatsMobileContainer: React.FC = () => {
	return (
		<div className="my-4" data-qa="signature-stats-section">
			<SignatureStatsContainerInner />
		</div>
	);
};
